var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHide = function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB3BE",
    fillRule: "evenodd",
    d: "m8.41 12 2.295 2.288a1.001 1.001 0 1 1-1.417 1.418L6.295 12.71a1 1 0 0 1 0-1.418l2.993-2.997a.997.997 0 0 1 1.417 0 1 1 0 0 1 0 1.419L8.41 12Zm6.001 0 2.295 2.288a1.004 1.004 0 0 1-1.417 1.418l-2.994-2.997a1 1 0 0 1 0-1.418l2.994-2.997a1.001 1.001 0 0 1 1.677.45c.092.346-.006.715-.26.968L14.411 12Z",
    clipRule: "evenodd"
  })));
};
export default SvgHide;